/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import * as utils from './Utils';
import { Loader } from '@thd-olt-component-react/loader';
import { SaveCardForm } from './SaveCardForm';
import { Purchaser } from './Purchaser';
import thdcustomer from '@thd-olt-global/thd-customer';
import { getCitiParameters, saveCard, redirectToPaymentCardsPage } from './SaveCardUtility';
import { AppContext } from '@thd-nucleus/app-render';
import { newRelic } from './Utils';

export const CommercialSaveCardToProfile = () => {

  const [postUrl, setPostUrl] = useState("");
  const [isPurchaser, setIsPurchaser] = useState(false);
  const { channel } = useContext(ExperienceContext);
  const { instance } = useContext(AppContext);
  const isSignInRequired = useConfigService('fs:COMMERCIAL_SIGN_IN_REQUIRED');
  const isFormEnabled = useConfigService('fs:COMMERCIAL_FORM_ENABLED');
  const isSCTPEnabled = useConfigService('fs:COMMERCIAL_SCTP_ENABLED');
  const isB2CUpgradeEnabled = useConfigService('fs:B2C_UPGRADE_ENABLED');
  const isAdminRequired = useConfigService('fs:COMMERCIAL_ADMIN_REQUIRED');
  const isCommercialSCTPB2CNativeEnabled = useConfigService('fs:COMMERCIAL_SCTP_B2C_NATIVE_APP_ENABLED');

  const nativeAppCheck = () => {
    return instance?.expContext?.experienceContext?.isConsumerApp
  };

  const overrideFS = (cookieName) => {
    return window.cookieUtils && window.cookieUtils.readBrowserCookie(cookieName);
  }

  useEffect(() => {
    if (window.document.getElementById('newRelicLog')
      && window.document.getElementById('newRelicLog').value) {
      newRelic(null, window.document.getElementById('newRelicLog').value);
    }

    if (utils.getURLParameters().cmp || utils.getURLParameters().step) {
      if (isSignInRequired || overrideFS('COMMERCIAL_SIGN_IN_REQUIRED')) {
        checkUserLoggedIn();
      } else {
        redirectToCiti();
      }
    } else if (isSCTPEnabled || overrideFS('COMMERCIAL_SCTP_ENABLED')) {
      if (getCitiParameters()) {
        saveCard(channel === 'mobile', true);
      } else {
        utils.newRelic(null, 'Parameters from Citi not available for save card', thdcustomer.svocID);
        redirectToPaymentCardsPage(false, 'PLCR_HOMEDEPOT');
      }
    }
  }, []);

  const citiUrl = (postUrl) => {
    const sc = (utils.getURLParameters().siteid && utils.getURLParameters().siteid === 'PLNP_HOMEDEPOT') ? '45014' : '40012';
    return postUrl + '?app=UNSOL&siteId=PLCR_HOMEDEPOT&sc='+ sc;
  }

  const redirectToCiti = (postUrl) => {
    const defaultCitiUrl = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action';
    let redirectUrl = citiUrl(postUrl ? postUrl : defaultCitiUrl)
    redirectUrl += utils.getURLParameters().cmp ? '&cmp=' + utils.getURLParameters().cmp : '';
    window.location.href = redirectUrl;
  }

  const checkB2CUpgradeEnabled = () => {
    if (!(isB2CUpgradeEnabled || overrideFS('B2C_UPGRADE_ENABLED'))){
      return false;
    }
    if (nativeAppCheck() && !(isCommercialSCTPB2CNativeEnabled || overrideFS('COMMERCIAL_SCTP_B2C_NATIVE_APP_ENABLED'))) {
      return false;
    }
    return true;
  }

  const checkUserLoggedIn = () => {
    if (thdcustomer.isLoggedIn) {
      if (!(thdcustomer.isB2BCustomer) && checkB2CUpgradeEnabled()) {
        utils.newRelic(null, 'redirect to upgrade in Commercial SCTP', thdcustomer.svocID);
        utils.redirectToUpgrade();
      } else if (thdcustomer.isB2BCustomer && thdcustomer.role && (isAdminRequired || overrideFS('COMMERCIAL_ADMIN_REQUIRED'))
        && thdcustomer.role.toUpperCase() !== 'ADMIN') {
        utils.newRelic(null, 'Admin role required message shown in Commercial SCTP', thdcustomer.svocID);
        setIsPurchaser(true);
      }
      else {
        getRedirectUrl()
          .then((data) => {
            if (data && data.postUrl) {
              utils.newRelic(200, 'success in get redirect url api ');
              if (isFormEnabled || overrideFS('COMMERCIAL_FORM_ENABLED')) {
                setPostUrl(data.postUrl);
              } else {
                redirectToCiti(data.postUrl);
              }
            } else if (data && data.response && data.response.status === 401) {
              utils.newRelic(data?.response?.status, 'Error in get redirect url api call');
              utils.redirectToLogin(true);
            } else {
              utils.newRelic(data?.response?.status, 'Error in get redirect url api call');
              redirectToCiti();
            }
          });
      }
    } else {
      utils.redirectToLogin(true);
    }
  }

  const getRedirectUrl = async () => {
    return await utils.getRedirectUrl(channel === 'mobile', true);
  }

  const generateFormParameters = () => {
    let environment = 'THDPROD1';
    if(window.location.origin.includes('qa74')) {
      environment = 'THDUAT1';
    } else if (window.location.origin.includes('qa71')) {
      environment = 'THDDEV1';
    }
    const originUrlParam = utils.getOriginPageUrl() ? '?originUrl=' + encodeURIComponent(utils.getOriginPageUrl()): '';
    const returnUrl =  '/myaccount/commercialsavecardtoprofile' + originUrlParam;

    return {
      postUrl: citiUrl(postUrl),
      customerId: thdcustomer.svocID + "_" + thdcustomer.userID,
      merchantUserType: 'S',
      env: environment,
      returnPage: returnUrl,
    }
  }

  const getLoaderMessage = () => {
    return utils.getURLParameters().step ? 'Redirecting To Citibank' : 'Saving Your Card';
  }

  const isSCTPForm = () => {
    return isSCTPEnabled || overrideFS('COMMERCIAL_SCTP_ENABLED')
  }

  if (isPurchaser) {
    return (
      <div className="loader-container">
        <Purchaser />
      </div>
    );
  }

  return (
    <div className="loader-container">
      <Loader active />
      <div className="u__husky u__bold u--paddingTop" id="loading-information-text">{getLoaderMessage()}</div>
      {postUrl !== "" && <SaveCardForm formData={generateFormParameters()} isSctpForm={isSCTPForm()} />}
    </div>
  );
};

CommercialSaveCardToProfile.propTypes = {};

CommercialSaveCardToProfile.displayName = 'CommercialSaveCardToProfile';

CommercialSaveCardToProfile.defaultProps = {
  name: '',
};
